import RemoteImage from '@atoms/RemoteImage';
import { Divider, Text, View } from '@components/primitives';
import { useNavigation } from '@react-navigation/native';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { onRedirectionHandler } from '@utils/utils';
import React from 'react';
import { Pressable, StyleProp, ViewStyle } from 'react-native';
import styles from './styles';

interface PromotionItem {
  imageLink: string;
  title: string;
  // Add other properties as needed
  [key: string]: any; // For any additional dynamic properties
}

interface TenantSettings {
  lang: string;
  // Add other tenant settings properties as needed
}

interface StoreState {
  tenantSettings: TenantSettings;
}

interface ProfileReferralProps {
  promotionData?: PromotionItem[];
  headerText?: Record<string, string>; // For language-based text or simple string
}

function ProfileReferral({ promotionData = [], headerText = {} }: Readonly<ProfileReferralProps>) {
  const navigation = useNavigation();
  const { tenantSettings } = getStore() as StoreState;
  const { lang } = tenantSettings;

  if (promotionData?.length > 0) {
    const e = AMPLITUDE_CONSTANTS.interactionBanner.banner_clicked;
    const headerContent = typeof headerText === 'string' ? headerText : headerText[lang];

    return (
      <>
        <View marginX="16px" marginY="16px">
          <Text testID="txtReferralHeader" variant="md-bold">
            {headerContent}
          </Text>
          <Pressable
            testID="goldBanner"
            style={styles.goldBanner as StyleProp<ViewStyle>}
            onPress={onRedirectionHandler(promotionData, navigation, e.name, {
              [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.others_page,
              [e.attributes.banner_name]: promotionData[0]?.title,
            })}>
            <RemoteImage uri={promotionData[0].imageLink} style={styles.goldImage} contentFit="contain" />
          </Pressable>
        </View>
        <Divider height="4px" backgroundColor={colors.neutral.mist} />
      </>
    );
  }
  return null;
}

export default ProfileReferral;
